import slug from "slugify";

export default function slugify(input: string){
    return slug(input.toLowerCase(),{ replacement: "-", lower: true });
}

